<template>
    <BasicDialog>
        <div class="d-flex flex-column align-center">




            <span class="auth-steps-dialog__icon-container">
                <slot name="icon" width="30" height="30"></slot>
            </span>



            <div class="auth-steps-dialog__title mt-6 mt-md-10 text-center">
                <slot name="title"></slot>
            </div>
            <div class="auth-steps-dialog__description mb-8 mt-1 text-center">
                <slot name="description"></slot>
            </div>




            <ErrorMessage :errorMessage="errorMessage" class="mb-5" />
            <SuccessMessage :successMessage="successMessage" class="mb-5" />





            <slot name="form"></slot>



            <slot name="footer"></slot>



        </div>
    </BasicDialog>
</template>







<script setup>

import BasicDialog from '@/components/Common/Basic-Dialog.vue';
import ErrorMessage from '@/components/Auth/Common/Messeges/ErrorMessage.vue';
import SuccessMessage from '@/components/Auth/Common/Messeges/SuccessMessage.vue';

const props = defineProps({
    errorMessage: {
        type: String,
        default: ''
    },
    successMessage: {
        type: String,
        default: ''
    }
});

</script>